import { useCreation } from 'ahooks'
import { useEffect, useState } from 'react'
import { STORAGE_REFRESH_TOKEN_KEY } from '../data/app'
import { RefreshTokenStorage } from '../helpers/authStorage'

export const useAuthStorage = () => {
  const refreshTokenStorage = useCreation<RefreshTokenStorage>(
    () => new RefreshTokenStorage(STORAGE_REFRESH_TOKEN_KEY),
    [],
  )
  const [isStorageLoaded, setIsStorageLoaded] = useState(false)

  const loadAuthStorage = async () => {
    await refreshTokenStorage.load()
    setIsStorageLoaded(true)
  }

  // biome-ignore lint/correctness/useExhaustiveDependencies: load once on mount; loadAuthStorage identity changes every render
  useEffect(() => {
    loadAuthStorage()
  }, [])

  return {
    refreshTokenStorage,
    isStorageLoaded,
  }
}
